import React, { Component } from 'react';
import getChartLine from "./getChartLine";

class REV extends Component {


    componentDidMount() {
        const data = this.props.data.GOPCompared || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "REV",
            dataY
        };
        getChartLine(defaultData);
        window.addEventListener('resize', () => {
            getChartLine(defaultData, null, true);
        });
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data.GOPCompared || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "REV",
            dataY
        };
        getChartLine(defaultData, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { });
    }

    render() {
        return (
            <div>
                <div className="total_style">经营毛利润</div>
                <div id="REV" style={{ height: 400, width: '100%' }} />
            </div>
        );
    }
}

export default REV;


// WEBPACK FOOTER //
// ./src/components/BI/home/REV.js